import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Img from '../../../components/Img';

import styles from '../search.scss';

const Filter = (props) => {
    const {
        searchFor = '',
        filterName,
        handleFilterClick,
        isActive,
        onClick,
        mobileOnly,
        desktopOnly,
        bothSportTypesSelected,
        noSportTypesSelected,
        utrFilter,
        isMemberFilter,
        'data-testid': dataTestId,
    } = props;

    const mobileClasses = mobileOnly ? 'd-inline-block d-md-none' : '';
    const desktopClasses = desktopOnly ? 'd-none d-md-inline-block' : '';
    const activeClass = isActive ? styles.searchFilterBtnActive : '';
    const sportSelectedClass = (bothSportTypesSelected || noSportTypesSelected) && !isMemberFilter ? styles.bothSportTypesSelected : '';
    const utrClasses = (bothSportTypesSelected || noSportTypesSelected) && !isMemberFilter ? `${styles.hoverText} ${styles.ratingTag}` : styles.paddingZero;
    const buttonStyles = `${styles.tagHover} ${styles.searchFilterBtn} ${activeClass} ${sportSelectedClass} ${mobileClasses} ${desktopClasses} text-capitalize`;
    const collegeCorner = 'collegeCorner';

    return (
        searchFor === collegeCorner ? (
            <div
                className={`${styles.searchFilterDiv} mr-3 ${mobileClasses} ${desktopClasses}`}
                data-testid={dataTestId && `${dataTestId}.btn`}
                onClick={() => {
                    if (onClick) {
                        onClick();
                    } else {
                        handleFilterClick(filterName);
                    }
                }}
            >
                <div className="value">{props.children}</div>
                <div className="ml-5 mt-0.5">
                    <i className="fas fa-solid fa-caret-down" />
                </div>
            </div>
        ) : (
            <button
                type="button"
                disabled={(bothSportTypesSelected || noSportTypesSelected) && !isMemberFilter}
                className={buttonStyles}
                data-testid={dataTestId && `${dataTestId}.btn`}
                onClick={() => {
                    if (onClick) {
                        onClick();
                    } else {
                        handleFilterClick(filterName);
                    }
                }}
            >
                {props.children}
                {utrFilter && !isMemberFilter && <span className={utrClasses} data-testid={dataTestId && `${dataTestId}.utr-hint`}>Select sport type to filter by ratings </span>}
            </button>
        )
    );
};

export const FilterModal = (props) => {
    const {
        title,
        handleFilterSubmit,
        onCloseClick,
        style,
        clearFilters,
        scrollable,
        'data-testid': dataTestId,
    } = props;

    const wrapperRef = useRef(null);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target) && onCloseClick) {
            onCloseClick();
        }
    };

    const scrollableClass = scrollable ? styles.searchFilterModalScrollable : '';

    return (
        <div className={`${styles.searchFilterModal} ${styles.searchFilterUTRModal} ${scrollableClass}`} style={style} ref={wrapperRef}>
            <div className={styles.searchFilterModalHeader}>
                <div className="container">
                    <div className="col d-flex justify-space-between align-items-center">
                        <div className="close-area" onClick={onCloseClick} data-testid={dataTestId && `${dataTestId}.close-btn`}>
                            <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                        </div>
                        <div className="title-span text-medium text-uppercase text-dark text-center" data-testid={dataTestId && `${dataTestId}.title`}>{title}</div>
                        {!!clearFilters && <div className="link underline" onClick={clearFilters} data-testid={dataTestId && `${dataTestId}.clear-btn`}>Clear</div>}
                    </div>
                </div>
            </div>
            {props.children}
            {handleFilterSubmit && (
                <div className={styles.searchFilterModalFooter}>
                    <button
                        type="button"
                        className={`btn btn-primary btn-small btn-block `}
                        onClick={handleFilterSubmit}
                        data-testid={dataTestId && `${dataTestId}.apply-btn`}
                    >
                        APPLY
                    </button>
                </div>
            )}
        </div>
    );
};

FilterModal.propTypes = {
    title: PropTypes.string.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    scrollable: PropTypes.bool,
    style: PropTypes.instanceOf(Object),
    'data-testid': PropTypes.string,
};

FilterModal.defaultProps = {
    scrollable: false,
    style: {},
    'data-testid': null,
};
export const FilterSection = (props) => {
    const { style, 'data-testid': dataTestId } = props;

    return (
        <div className={styles.searchFilterModalBody} style={style} data-testid={dataTestId}>
            {props.children}
        </div>
    );
};

FilterSection.propTypes = {
    style: PropTypes.instanceOf(Object),
    'data-testid': PropTypes.string,
};

FilterSection.defaultProps = {
    style: {},
    'data-testid': undefined,
};

Filter.propTypes = {
    searchFor: PropTypes.string,
    filterName: PropTypes.string,
    handleFilterClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    mobileOnly: PropTypes.bool.isRequired,
    desktopOnly: PropTypes.bool,
    bothSportTypesSelected: PropTypes.bool,
    noSportTypesSelected: PropTypes.bool,
    utrFilter: PropTypes.bool,
    'data-testid': PropTypes.string,
};

Filter.defaultProps = {
    searchFor: '',
    filterName: '',
    isActive: false,
    desktopOnly: false,
    bothSportTypesSelected: false,
    noSportTypesSelected: false,
    utrFilter: false,
    'data-testid': null,
};
export default Filter;
